import axios from "axios";
import { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import api from "../../api/api";
import "./SearchPage.scss";
import SearchPageContent from "./SearchPageContent";
import SearchPageKeyword from "./SearchPageKeyword";
import SearchPageTitleBookmark from "./SearchPageTitleBookmark";

const SearchPage = () => {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const platformType = useSelector(
    (state) => state.platformTypeChecker.platformType,
  );
  const [searchKeyword, setSearchKeyword] = useState([]);
  const [titleBookmark, setTitleBookmark] = useState([]);
  const [contentList, setContentList] = useState([]);
  const [tabKey, setTabKey] = useState("all");

  const { value } = useParams();
  // const navigate = useNavigate();
  var host = window.location.host;
  var protocol = window.location.protocol;
  const basePath =
    manualType === "g" && platformType === "kcp"
      ? manualType + "/" + platformType
      : manualType;
  useEffect(() => {
    axios
      .get(api.manual.search, { params: { search: value } })
      .then((res) => {
        setSearchKeyword(res.data.searchKeyword);
        setTitleBookmark(res.data.titleBookmark);
        setContentList(res.data.contentList);
      })
      .catch((error) => console.log(error));
  }, [value]);
  return (
    <div className="search-main">
      <h3>
        <span className="search-word">'{value}'</span> 검색 결과
      </h3>
      <Tabs
        id="controlled-tab-example"
        activeKey={tabKey}
        onSelect={(k) => setTabKey(k)}
        className="mb-3"
      >
        <Tab eventKey="all" title="문서명/본문">
          <SearchPageContent
            contentList={contentList}
            basePath={basePath}
            value={value}
          />
        </Tab>
        <Tab eventKey="keyword" title="키워드">
          <SearchPageKeyword
            searchKeyword={searchKeyword}
            basePath={basePath}
            value={value}
          />
        </Tab>
        <Tab eventKey="titleBookmark" title="문서명/목차">
          <SearchPageTitleBookmark
            titleBookmark={titleBookmark}
            basePath={basePath}
            value={value}
          />
        </Tab>
      </Tabs>
    </div>
  );
};
export default SearchPage;
